module.exports = __webpack_public_path__ + "img/lira-logo-1-1.e044ba7b.png";